import { useEffect, useRef, useState } from "react";

// Triggers when the element enters the viewport once.
// Has a fallback timeout that forces inView=true so content NEVER stays hidden
// (defensive fix for browsers / scroll positions where IntersectionObserver
// fails to fire).
export default function useInView({ threshold = 0, rootMargin = "0px 0px -10% 0px", fallbackMs = 1200 } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        observer.disconnect();
      }
    }, { threshold, rootMargin });
    observer.observe(node);

    // Fallback: force-show if the observer hasn't fired (e.g. element already
    // above the viewport on initial paint).
    const fallback = setTimeout(() => setInView(true), fallbackMs);

    return () => {
      observer.disconnect();
      clearTimeout(fallback);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [ref, inView];
}
